import { Paper, Typography, Stack, Box } from '@mui/material';
import {
  BeachAccess as PendingIcon,
  CheckCircle as GozadosIcon,
  MonetizationOn as VendidosIcon,
  Warning as VencerIcon,
} from '@mui/icons-material';
import type { VacacionResumenTrabajador } from '../types/beneficios';

interface Props {
  cuenta: VacacionResumenTrabajador | null;
}

interface CardProps {
  label: string;
  value: number;
  color: string;
  icon: React.ReactNode;
  suffix?: string;
}

function SummaryCard({ label, value, color, icon, suffix = 'días' }: CardProps) {
  return (
    <Paper sx={{ p: { xs: 1.5, sm: 2 }, flex: 1, minWidth: { xs: 'calc(50% - 8px)', sm: 150 }, borderTop: 3, borderColor: color }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
        {icon}
        <Typography variant="caption" color="text.secondary">{label}</Typography>
      </Stack>
      <Typography variant="h6" sx={{ fontWeight: 700, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
        {value} <Typography component="span" variant="body2" color="text.secondary">{suffix}</Typography>
      </Typography>
    </Paper>
  );
}

export default function VacacionSummaryCards({ cuenta }: Props) {
  if (!cuenta) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 1, sm: 2 }, mb: 2 }}>
      <SummaryCard label="Días Pendientes" value={cuenta.totalDiasPendientes}
        color="primary.main" icon={<PendingIcon fontSize="small" color="primary" />} />
      <SummaryCard label="Días Gozados" value={cuenta.totalDiasGozados}
        color="success.main" icon={<GozadosIcon fontSize="small" color="success" />} />
      <SummaryCard label="Días Vendidos" value={cuenta.totalDiasVendidos}
        color="info.main" icon={<VendidosIcon fontSize="small" color="info" />} />
      <SummaryCard label="Por Vencer" value={cuenta.periodosPorVencer}
        color="warning.main" icon={<VencerIcon fontSize="small" color="warning" />} suffix="periodos" />
    </Box>
  );
}
